import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelBTerm } from "../../types/levelb-reports";

export const useGetLevelBTerms = (startDate?: string, endDate?: string) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchTerms = async (): Promise<LevelBTerm[]> => {
        try {
            const params = new URLSearchParams();
            
            if (startDate) {
                params.append('startDate', startDate);
            }
            if (endDate) {
                params.append('endDate', endDate);
            }

            const url = params.toString() 
                ? `/api/levelbreports/terms?${params.toString()}`
                : '/api/levelbreports/terms';
            
            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            throw new Error(t("levelBReports.errors.getTerms"));
        }
    };

    return useQuery({
        queryKey: ["levelBTerms", startDate, endDate],
        queryFn: fetchTerms,
    });
};

